import api from "../..";
import type { PatchPayoutParams } from "./types";

export const patchPayout = async ({ id, body }: PatchPayoutParams): Promise<boolean> => {

  return await api.patch(`/payments/payout/${id}/`, body)
  .then(() => true)
  .catch(() => false);
};
